export default __webpack_public_path__ + "static/media/banner_2_2W.75931544.jpg";